export default {
  patients: null,
  doctors: null,
  locations: null,
  appointment_types: null,
  statuses: null
}
